/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { useMemo } from 'react';

import { useCollectionSurtitle } from '../../hooks/useSurtitle';

import Blocks from '../blocks/Blocks';
import CollectionDefaultHeader from '../headers/CollectionDefaultHeader';
import InfiniteItemsBlocks from '../lists/InfiniteItemsBlocks';
import SectionTitle from '../typography/SectionTitle';

import styles from '../../styles/collections/default-collection.module.css';

interface DefaultCollectionProps {
    slug: string;
    id?: string | null;
    type?: string | null;
    surtitle?: string | null;
    title?: string | null;
    description?: string | null;
    header?: CollectionHeader | null;
    metadata?: CollectionMetadata | null;
    image?: Image | null;
    seasons?: CollectionSnippet[] | null;
    children?: CollectionSnippet[] | null;
    current?: boolean;
    className?: string;
}

function DefaultCollection({
    id: collectionId = null,
    slug = null,
    type = null,
    surtitle = null,
    title = null,
    description = null,
    header = null,
    metadata,
    image,
    current,
    className,
}: DefaultCollectionProps) {
    const { brands, sponsors } = metadata || {};

    const finalSurtitle = useCollectionSurtitle({ type, surtitle, metadata });

    return (
        <div className={classNames([styles.container, className])}>
            <CollectionDefaultHeader
                type={type}
                title={title}
                surtitle={finalSurtitle}
                description={description}
                brands={brands}
                sponsors={sponsors}
                background={
                    type === 'magazine'
                        ? {
                              color: '#fff',
                          }
                        : null
                }
                {...header}
                image={header !== null ? header.image || image : image}
                placeholder={collectionId === null}
                className={styles.header}
            />
            <main className={styles.content}>
                <InfiniteItemsBlocks
                    query={{
                        collection: collectionId,
                    }}
                    disabled={collectionId === null}
                    className={styles.blocks}
                    cardTheme="box-translucent-dark"
                    cardWithout={['brand-icon', 'serie', 'collection']}
                />
            </main>
        </div>
    );
}

export default DefaultCollection;
